import { FC } from 'react';

import LanguageSelector from './language-selector';
import * as Styled from './styles';

interface Props {
    page: 'welcome' | 'intakeForm';
}

export const EpionCheckInHeader: FC<Props> = ({ page }) => {
    return (
        <Styled.Container>
            <Styled.Logo
                src="https://s3.amazonaws.com/check-in-production-enc/practices/logos/000/000/848/original/Screenshot_2023-09-17_at_7.39.46_PM.png?1694994075"
                alt="CityMD"
            />
            <LanguageSelector page={page} />
        </Styled.Container>
    );
};
